<template>
  <div class="relative overflow-hidden rounded-full w-fit mr-8">
    <div
      :class="[
        'transition-background absolute left-0 right-0 top-0 bottom-0 ',
        remainingTime > 9 ? 'w-0' : 'w-full',
      ]"
      :style="{
        transition: `all ${cancelTime - 1}s ease-in-out;`,
      }"
    ></div>
    <Button
      px
      class="relative z-10 left-0 right-0 h-full px-10 py-4"
      @click="handleClick"
      :style="remainingTimeButtonText + remainingTimeButtonBackground"
    >
      <slot />
      <template v-if="showTimer">({{ remainingTime }})</template>
    </Button>
  </div>
</template>

<script>
const defaultCancelTime = 10; // seconds
import { mapGetters } from "vuex";
export default {
  data() {
    return {
      timer: null,
      remainingTime: 0,
    };
  },
  computed: {
    ...mapGetters("Theme", [
      "remainingTimeButtonBackground",
      "remainingTimeButtonText",
    ]),
  },
  props: {
    showTimer: {
      type: Boolean,
      default: true,
    },
    cancelTime: {
      type: Number,
      default: defaultCancelTime,
    },
  },
  mounted() {
    this.remainingTime = this.cancelTime;

    // make `this` available in callback functions
    const self = this;

    this.timer = setInterval(() => {
      self.remainingTime -= 1;
    }, 1000);
  },
  methods: {
    handleClick() {
      if (this.timer) clearInterval(this.timer);
      this.$emit("click");
    },
  },
  watch: {
    remainingTime(t) {
      if (t === 0) {
        clearInterval(this.timer);
        this.$emit("timedOut");
      }
    },
  },
  destroyed() {
    if (this.timer) clearInterval(this.timer);
  },
};
</script>

<style lang="scss"></style>
